// @flow
import { createSelector } from "reselect"
import type { InputSelector } from "reselect"

import type Options from "../../records/Options"
import { getAffiliateThisSession, getBrandingAffilId, getRawAffilId } from "./reducer"
import { getUserAffilId } from "../user/index"
import { formatSimpleAffilId, getAffilidAccordingToPriority } from "../affilId/tools"

type State = {
  options: Options,
}

export const optionsSelector = (state: State): Options => state.options

export const languageSelector: InputSelector<State, *, string> = createSelector(
  optionsSelector,
  options => options.language,
)

// Used to detect automated tests stream
export const isAutomatedTestSelector: InputSelector<State, *, boolean> = createSelector(
  optionsSelector,
  options => options.isAutomatedTest,
)

// Affiliate settings
// ===

// The only proper way how get affilid
export const getAffilId: $FlowFixMe = createSelector(
  getAffiliateThisSession,
  getRawAffilId,
  getUserAffilId,
  getBrandingAffilId,
  getAffilidAccordingToPriority,
)

// Discard market information `skypicker_cz` -> `skypicker`
export const getSimpleAffilId: $FlowFixMe = createSelector(
  getAffilId,
  formatSimpleAffilId,
)
